var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGcLkwhqG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97656 23.0511L17.2922 23.5977V21.941C17.2922 21.472 17.7389 21.0906 18.2887 21.0906H20.077C21.7602 21.0906 23.1298 19.9222 23.1298 18.4864V15.9138V15.3001L23.8489 15.3027L24.1313 15.3038C24.5145 15.3038 24.8558 15.1385 25.0493 14.861C25.2439 14.5824 25.2513 14.2464 25.0684 13.962L23.2179 11.0773L23.1298 10.9401V10.7841V9.01034C23.1298 4.97697 19.5762 2.16 15.0002 1.75488",
    stroke: "#25BBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0842 6.59273C15.0019 4.46925 12.7759 3.02824 10.591 3.59698C8.53008 0.752988 3.7077 1.92848 3.54272 5.37955C-0.331859 6.36524 0.409992 11.75 4.49053 11.75H14.136C17.3924 11.75 18.0933 7.50303 15.0842 6.59273Z",
    stroke: "#2593FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98157 14.3794L5.98438 19.9114",
    stroke: "#32239B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23773 14.3794L2.90283 18.0769",
    stroke: "#32239B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7261 14.3794L10.6162 17.4537",
    stroke: "#32239B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcLkwhqG);
export default __webpack_public_path__ + "static/media/GcLkwhqG.dabca40498b66ac086655e3bab5ac7ed.svg";
export { ForwardRef as ReactComponent };